import Vue from 'vue';



import App from './App.vue';
import router from './router';
import store from './store/index';
import './registerServiceWorker';
import VueI18n from 'vue-i18n';
// import VueLogger from 'vuejs-logger';
import messages from './assets/translations.json';
import BootstrapVue, { ModalPlugin } from 'bootstrap-vue';
import registerEvents from './common/events';

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(ModalPlugin);
Vue.use(VueI18n);

// // Logging
// const isProduction = process.env.NODE_ENV === 'production';
// const options = {
//     isEnabled: true,
//     logLevel : isProduction ? 'error' : 'debug',
//     stringifyArguments : false,
//     showLogLevel : true,
//     showMethodName : true,
//     separator: '|',
//     showConsoleColors: true
// };
// Vue.use(VueLogger, options);


const i18n = new VueI18n({
  locale: 'da',
  messages,
});



registerEvents();



new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
